export const trailingSlashit = (string: string): string => {
  return string.replace(/\/?$/, '/');
};
